import React from 'react'

import { ReactComponent as PlusIcon } from '@app/assets/Small/Outline/Plus.svg'
import { useIntl } from '@app/intl/Intl'
import { bemJoin } from '@app/lib/bem'
import { IconButton } from '@app/lib/inputs/IconButton/IconButton'

import './styles.scss'

type UploadIconButtonProps = {
  onFileUpload: () => void
  disabled?: boolean
}

export const UploadIconButton = ({ onFileUpload, disabled }: UploadIconButtonProps) => {
  const b = bemJoin('upload-icon-button')
  const { formatMessage } = useIntl()

  return (
    <IconButton
      aria-label={formatMessage({ id: 'Lib.UploadIconButton.Aria.Label' })}
      className={b()}
      onClick={onFileUpload}
      color='secondary'
      variant={'solid'}
      shape={'circle'}
      size='lm'
      disabled={disabled}
    >
      <PlusIcon />
    </IconButton>
  )
}
